"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TranslationsNamespaceProvider = require("./TranslationsNamespaceProvider");
Object.keys(_TranslationsNamespaceProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TranslationsNamespaceProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TranslationsNamespaceProvider[key];
    }
  });
});
var _translationsNamespaceContext = require("./translationsNamespaceContext");
Object.keys(_translationsNamespaceContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _translationsNamespaceContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _translationsNamespaceContext[key];
    }
  });
});
